import { render, staticRenderFns } from "./SoldTicketsList.vue?vue&type=template&id=d58c74a4"
import script from "./SoldTicketsList.vue?vue&type=script&lang=js"
export * from "./SoldTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports